var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4.5C4.44772 4.5 4 4.05228 4 3.5H3.33333C3.14924 3.5 3 3.64924 3 3.83333V5.5H13V3.83333C13 3.64924 12.8508 3.5 12.6667 3.5H12C12 4.05228 11.5523 4.5 11 4.5C10.4477 4.5 10 4.05228 10 3.5H6C6 4.05228 5.55228 4.5 5 4.5ZM10 1.5H6V1C6 0.447715 5.55228 0 5 0C4.44772 0 4 0.447715 4 1V1.5H3.33333C2.04467 1.5 1 2.54467 1 3.83333V13.1667C1 14.4553 2.04467 15.5 3.33333 15.5H12.6667C13.9553 15.5 15 14.4553 15 13.1667V3.83333C15 2.54467 13.9553 1.5 12.6667 1.5H12V1C12 0.447715 11.5523 0 11 0C10.4477 0 10 0.447715 10 1V1.5ZM3 7.5V13.1667C3 13.3508 3.14924 13.5 3.33333 13.5H12.6667C12.8508 13.5 13 13.3508 13 13.1667V7.5H3Z",
    fill: "#E30031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.b46291dd75f668a8f3eaee82f22e94d6.svg";
export { ForwardRef as ReactComponent };